import React from 'react';
import classNames from 'classnames';

import { FCWithChildren } from '@types';

type InputSectionGroupProps = React.HTMLAttributes<HTMLDivElement> & {
  className?: string;
};

type InputSectionGroupItemProps = React.HTMLAttributes<HTMLDivElement> & {
  className?: string;
};

const InputSectionGroupItem: FCWithChildren<InputSectionGroupItemProps> = ({
  children,
  className,
  ...other
}) => {
  return (
    <div className={classNames('input-section-group__item w-full', className)} {...other}>
      {children}
    </div>
  );
};

const InputSectionGroup: InputSectionGroupComponent = ({ children, className, ...other }) => {
  return (
    <div className={classNames('input-section-group w-full', className)} {...other}>
      {children}
    </div>
  );
};

type InputSectionGroupComponent = FCWithChildren<InputSectionGroupProps> & {
  Item: typeof InputSectionGroupItem;
};

InputSectionGroup.Item = InputSectionGroupItem;

export default InputSectionGroup;
